import { controls } from "../../controls";

const rp402 = {
  label: "Custmoer Correction",
  pageLabel: "Custmoer Correction",
  starting: true,
  url: "rp402",

  pageType: "history",
  filter: [

    ...controls.displayText({ tab: "filter", label: "Parent Branch", width: "col-sm-2" }),
    ...controls.branch({ tab: "filter", defaultValue: "assigned_branch" }),
    ...controls.showData({ tab: "filter", data: "branch_display", name: "branch_display", width: "col-sm-2", displaytype: 'small' }),

    ...controls.displayText({ tab: "filter", label: "Product Code", width: "col-sm-2" }),
    ...controls.product({ tab: "filter" }),
    ...controls.showData({ tab: "filter", data: "product_code_display", name: "product_code_display", width: "col-sm-2", displaytype: 'camelcase' }),

    ...controls.displayText({ tab: "filter", label: "Customer Number", width: "col-sm-2" }),
    ...controls.customerNumber({ tab: "filter" }),
    ...controls.showData({ tab: "filter", data: "customer_number_display", name: "customer_number_display", width: "col-sm-2", displaytype: 'titlecase' }),

    ...controls.displayText({ tab: "filter", label: "Correction From Date", star: true, width: "col-sm-2 " }),
    ...controls.magicDate({ tab: "filter", isRequired: true, name: "correction_from_date", width: "col-sm-2" }),

    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-2 " }),

    ...controls.displayText({ tab: "filter", label: "Correction To Date", star: true, width: "col-sm-2 " }),
    ...controls.magicDate({ tab: "filter", isRequired: true, name: "correction_to_date", width: "col-sm-2" }),

    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-2 " }),

    ...controls.displayText({ tab: "Modal", label: "Entry By", width: "col-sm-2" }),
    ...controls.numberOnly({ tab: "Modal", name: "entry_by", width: "col-sm-2", placeHolder: "Pf Number" }),

    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-4 " }),

    ...controls.checkBox({ tab: "filter", label: "Deleted", name: "isDeleted", width: "col-sm-2" }),

    ...controls.checkBox({ tab: "filter", label: "Modified", name: "isModified", width: "col-sm-2" }),
  ],

  form: [],

  history: {
    perPage: 10,
    reportHeader: "Custmoer Correction Report",
    pdfProps: { pageSize: "A4", pageOrientation: "landscape" },
    displayColumns: [
      {
        Header: "Sr",
        type: "autoinc",
        accessor: "srno",
        width: 30
      },
      {
        Header: "Correction Date",
        accessor: "correction_date",
        width: 100,
        rwidth: 80
      },
      {
        accessor: "correction_by",
        Header: "Correction By",
        width: 250,
        rwidth: 200
      },
      {
        accessor: "mode",
        Header: "Mode",
        width: 70,
        rwidth: 50

      },
      {
        accessor: "ac_number",
        Header: "Ac Number",
        width: 250,
        rwidth: 200
      },
      {
        accessor: "field_name",
        Header: "Field Name",
        width: 150,
        rwidth: 100
      },
      {
        accessor: "old_value",
        Header: "Old Value",
        rwidth: "*"
      },
      {
        accessor: "new_value",
        Header: "New Value",
        rwidth: "*"
      }





    ]
  }
};

export default rp402;